/**
 * @file location-page的更多服务
 * @author
 */

import React from 'react';
import CustomButton from '../../../components/CustomButton/index';

import {recordProxy, handleLogin} from '../../../util';
import {moreServiceList} from '../../../pages/normalLandPage/constans';

import {ICompMoreServiceProps as IProps} from '../locationResInterface';

export default function CompMoreService(props: IProps) {
    const {
        phoneList,
        fetchUserInfo,
        history,
        btnList,
        userInfo,
        urlParam,
        path,
        title,
        tag,
    } = props;
    const jump = (type) => {
        const phoneListParam = phoneList.length > 0
            ? encodeURIComponent(JSON.stringify(phoneList))
            : '';
        const pointParam = {
            title,
            tag,
            type
        };
        recordProxy(`${path}-btn`, 'click', JSON.stringify(pointParam));

        let routerPath = '';
        switch (type) {
            case 'hesuan':
                routerPath = '/location_page?' + urlParam;
                break;
            case 'occupy':
                if (userInfo.code === 200) {
                    routerPath = '/occupy?phones=' + phoneListParam;
                } else {
                    handleLogin(fetchUserInfo);
                    return;
                }
                break;
            case 'feedback':
                if (userInfo.code === 200) {
                    routerPath = '/feedback?phones=' + phoneListParam
                        + '&pagef=phonesearch';
                } else {
                    handleLogin(fetchUserInfo);
                    return;
                }
                break;
            default:
        }
        routerPath && history.push(routerPath);
    };
    return (<div className="more-service">
        <p className="title">更多服务</p>
        <div className="service-list">
            {moreServiceList.map(item => {
                if (btnList.includes(item.type)) {
                    return <CustomButton
                        key={item.type}
                        className={ item.color === 'blue' ? 'service-btn blue' : 'service-btn'}
                        type="default"
                        onClick={() => jump(item.type)}
                    >
                        {item.text}
                    </CustomButton>;
                }
            })}
        </div>
    </div>);
}